import { axiosApi } from '@/config/http';
import type { ApiResponse } from '@/config/http/types';
import type { AccountPayment, PaymentOrder } from './types';

export const getRetentionsByVat = async (vat: string) => {
  try {
    const response = await axiosApi.get<ApiResponse<AccountPayment[]>>(
      `/v1/odoo/arg/retentions/by-vat/${vat.replace(/[^0-9]/g, '')}`,
    );
    return response.data.response;
  } catch (error) {
    return [] as AccountPayment[];
  }
};

export const getRetentionExportByPaymentId = async (payment_id: string) => {
  try {
    const response = await axiosApi.get(
      `/v1/odoo/arg/retentions/${payment_id}/export`,
      {
        responseType: 'blob',
      },
    );

    const contentDisposition = response.headers['content-disposition'];
    const filename = contentDisposition
      ?.split('filename=')[1]
      .replace(/^"|"$/g, '');
    return {
      response: response.data,
      filename: filename,
    };
  } catch (error) {
    return {
      response: null,
      filename: '',
    };
  }
};

export const getPaymentOrdersByVat = async (vat: string) => {
  try {
    const response = await axiosApi.get<ApiResponse<PaymentOrder[]>>(
      `/v1/odoo/arg/account-payments/by-vat/${vat.replace(/[^0-9]/g, '')}`,
    );

    response.data.response = response.data.response.map(order => ({
      ...order,
      date: new Date(order.date),
    }));

    return response.data.response;
  } catch (error) {
    return [] as PaymentOrder[];
  }
};

export const getPaymentOrderExportByPaymentId = async (payment_id: string) => {
  try {
    const response = await axiosApi.get(
      `/v1/odoo/arg/account-payments/${payment_id}/export`,
      {
        responseType: 'blob',
      },
    );

    const contentDisposition = response.headers['content-disposition'];
    const filename = contentDisposition
      ?.split('filename=')[1]
      .replace(/^"|"$/g, '');
    return {
      response: response.data,
      filename: filename,
    };
  } catch (error) {
    return {
      response: null,
      filename: '',
    };
  }
};

export default {
  getRetentionsByVat,
  getRetentionExportByPaymentId,
  getPaymentOrdersByVat,
  getPaymentOrderExportByPaymentId,
};
